import { fg } from '@atlaskit/platform-feature-flags';

import { type EditionAwarenessContextType } from './edition-awareness-context';

export function isEligibleForChooseYourEdition(context: EditionAwarenessContextType): boolean {
	const { product, edition, billingSourceSystem, isInCollection, isInTrial } = context;

	return (
		!isInCollection &&
		product === 'confluence' &&
		edition === 'free' &&
		!isInTrial &&
		billingSourceSystem === 'CCP' &&
		fg('confluence_free_choose_your_edition_kill_switch')
	);
}
